import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

const ConfirmDeleteModal = ({ open, onClose, onConfirm, titulo, mensagem }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{titulo || "Confirmar exclusão"}</DialogTitle>
            <DialogContent>
                <Typography>
                    {mensagem || "Deseja realmente excluir este produto?"}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Cancelar
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained">
                    Excluir
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteModal;
